import React, { Component } from 'react';
import { MDBFooter, MDBContainer } from 'mdbreact';
import { Typography } from '@material-ui/core';

class Footer extends Component {

    render() {
        return(
            <MDBFooter color="peach-gradient" className="font-small pt-4 mt-4">
                    <MDBContainer fluid className="text-center py-3">
                        <Typography>
                        &copy; {new Date().getFullYear()} Copyright: Artistic Wizard
                        </Typography>
                    </MDBContainer>
                <div className="footer-copyright text-center py-3">
                    <MDBContainer fluid>
                        <Typography>
                        &copy; {new Date().getFullYear()} Wesbite Design Copyright: Lachlan McKeith
                        </Typography>
                    </MDBContainer>
                </div>
            </MDBFooter>
        )
    }
}

export default Footer;